/**
 * Serializa filtros a query string.
 *
 * Descarta `undefined`, `null` y `''` y ordena las claves: el mismo filtro
 * produce siempre la misma URL, asi que la cache de React Query no se fragmenta
 * por el orden en que se escribieron los campos.
 *
 * Un array se serializa **repitiendo la clave** (`?k=a&k=b`), que es como
 * FastAPI recibe un `list[str]`. Con `set()` y un `String(value)` habria viajado
 * `?k=a,b`, un solo valor con una coma adentro, y el backend habria filtrado por
 * una categoria llamada literalmente "a,b" — cero resultados, sin error.
 */
export function toSearchParams(filters: Record<string, unknown>): string {
  const params = new URLSearchParams()

  for (const [key, value] of Object.entries(filters).sort(([a], [b]) => a.localeCompare(b))) {
    if (value === undefined || value === null || value === '') continue
    if (typeof value === 'boolean') {
      params.set(key, value ? '1' : '0')
      continue
    }
    if (Array.isArray(value)) {
      for (const item of value) {
        if (item === undefined || item === null || item === '') continue
        params.append(key, String(item))
      }
      continue
    }
    params.set(key, String(value))
  }

  const query = params.toString()
  return query ? `?${query}` : ''
}
